import {
    useColorMode
} from '@chakra-ui/react';

import {
    Box,
    Flex,
    Heading,
    Spinner,
    Tab,
    TabList,
    Tabs,
    Text
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import useGetBestPriceData from '../../hooks/useGetBestPriceData';
import { useSession } from '../../hooks/useSession';

  import { Link } from 'react-router-dom';
import { getBestPricePagePath } from '../../App';
import Carousel from '../../components/carousel';
import HistoryTable from '../../components/history-table';
import Layout from '../../components/layout';
import fetchLocFromIP from '../../helpers/fetchLocFromIP';
import { IBookWithValues, INetProfit } from '../../types';

export default function BestPrice() {
    const { colorMode, toggleColorMode } = useColorMode();

    const session = useSession();
    const [currentFilterIndx, setCurrentFilterIndx] = useState(0);
    const [region, setRegion] = useState(null);
    // const dateFilters = [
    //     {
    //         label: 'Total',
    //         value: null,
    //     },
    //     {
    //         label: 'Last 3 Months',
    //         value: Dayjs().subtract(3, 'months').format('YYYY-MM-DD'),
    //     },
    //     {
    //         label: 'Last 6 Month',
    //         value: Dayjs().subtract(6, 'months').format('YYYY-MM-DD'),
    //     },
    //     {
    //         label: 'Last Year',
    //         value: Dayjs().subtract(12, 'months').format('YYYY-MM-DD'),
    //     },
    // ];

    const dateFilters = [
        {
            label: 'Net Profit',
            value: null,
        }
    ];

    const currentFilter = dateFilters.find(
        (filter, index) => currentFilterIndx === index
    );

    const { loading, result, error } = useGetBestPriceData(
        session?.token!,
        session?.internalId!,
        currentFilter?.value!
    );

    var [bestPriceData, netProfits] = result || [null, null];

    useEffect(() => {
        if (session?.uiMode && session?.uiMode != 'system'  && session?.uiMode != colorMode) toggleColorMode()
    }, []);

    const getUserAccountAndRegion = (
        regionAbbr: string,
        bookAbbr: string,

    ): any => {

        const selectedUserAccount = session?.userAccounts?.find(
            userAccount => userAccount.book.abbr == bookAbbr
        );

        const selectedUserAccountRegion = selectedUserAccount?.userAccountRegions?.find(
            useerAccountRegion => useerAccountRegion.bookRegion.abbr == regionAbbr
        );

        return [selectedUserAccount,selectedUserAccountRegion]
    };


    const validateBookRegion = (region: string,) => {

        let isValid = false;
        session?.userAccounts?.forEach(({ userAccountRegions, book }: any) => {
          userAccountRegions?.forEach(({ bookRegion }: any) => {
            if (bookRegion.abbr === region) {
              isValid = true;
            }
          });
        });

        return isValid;
      }

    const getRegionFromBettorAccounts = () => {
        const maxTimeCreatedNetProfit = netProfits?.reduce((maxNetProfit: INetProfit | null, currentNetProfit: INetProfit) => {
            const currentTimestamp = new Date(currentNetProfit.timeCreated).getTime();
            const maxTimestamp = maxNetProfit ? new Date(maxNetProfit.timeCreated).getTime() : 0;

            return currentTimestamp > maxTimestamp ? currentNetProfit : maxNetProfit;
          }, null);
          return maxTimeCreatedNetProfit?.bookRegion.abbr
    }

    const getRegion = async() => {
        var regionAbbr = await fetchLocFromIP();
        let isValid = validateBookRegion(regionAbbr);
        //If location is not valid then choose region from most recently created bettorAccount
        if (!isValid){
            regionAbbr = getRegionFromBettorAccounts()
        }
        //Want to add a dropdown select region in this case
        if (!regionAbbr){
            regionAbbr = 'nj';
        }
        setRegion(regionAbbr);
    }

    useEffect(() => {
        getRegion();
      }, [])

    const filterAndSortBooks = (books: IBookWithValues[]) => {

        books.sort((a, b) => ((b.bonus || 0) + (b.missedValueEstimate ||0)) - ((a.bonus || 0) + (a.missedValueEstimate ||0)))
        books = books.filter(a => a.bonus + a.missedValueEstimate != 0).filter(b => !netProfits?.map(np => np.book.id).includes(b?.id))
        return books
    }

    var booksWithValues: IBookWithValues[] = [];

    //Map to desired object while filtering out null regions
    for (const [abbr, values] of Object.entries(bestPriceData?.missedValue || {})) {
        const [ua, uar] = getUserAccountAndRegion(region || '', abbr);

        if (!uar) continue;

        let url = uar?.bookRegion?.url || ua?.book?.url
        const resultObject = {
            id: ua.book.id as string,
            name: ua.book.name as string,
            abbr: ua.book.abbr as string,
            missedValueEstimate: values.missedValueEstimate as number,
            missedValueParlay: values.missedValueParlay as number,
            //totalSlips: bestPriceData?.totalSlips as number,
            //missedValueSlips: values.missedValueSlips as number,
            bonus: uar?.bookRegion?.bonus || 0 as number,
            url: url as string
        };

        booksWithValues.push(resultObject);
    }

    booksWithValues = filterAndSortBooks(booksWithValues)

    return (
        <Layout
            colorMode = {colorMode}
            size="large"
            alert={session?.user?.isSandbox ? 'SANDBOX MODE' : ''}
        >
            <Flex
                direction="column"
                align="center"
                gap={{ base: '24px', sm: '40px' }}
                w="full"
            >
                <Heading size={{ base: "md", sm: "lg" }}>How Much Have You Left on The Table?</Heading>
                <Box w="full">
                    <Tabs size={{ base: "lg", sm: "lg" }} isFitted={true} onChange={setCurrentFilterIndx}>
                        <TabList>
                            {dateFilters.map((filter, indx) => (
                                <Tab key={indx}>{filter.label}</Tab>
                            ))}
                        </TabList>
                    </Tabs>

                    {loading || !booksWithValues || !netProfits ? (
                        <Flex
                            w="full"
                            h="full"
                            justifyContent="center"
                            alignItems="center"
                            mt={{ base: '24px', sm: '50px' }}
                        >
                            <Spinner />
                        </Flex>
                    ) : (
                        <Box w="full" mt={{ base: '20px', sm: '50px' }}>
                            <Flex
                                direction="column"
                                align="center"
                                w="full"
                                gap={{ base: '20px', sm: '50px' }}
                                textAlign="center"
                            >
                                {/* <Text size={{ base: "md", sm: "lg" }} fontWeight="bold">
                                    Net Profit
                                </Text> */}
                                <HistoryTable netProfits={netProfits} cid={session?.cid || ''} />
                                {/* <Text
                                    mb="-10px"
                                    size={{ base: "md", sm: "lg" }}
                                    maxW={{ base: '326px', sm: '477px' }}
                                    fontWeight="bold"
                                    //textDecoration="underline"
                                >
                                    Missed Value*
                                </Text> */}
                            </Flex>
                                <Tabs size={{ base: "lg", sm: "lg" }} mt={{ base: '20px', sm: '50px' }} mb={{ base: '20px', sm: '50px' }} isFitted={true}>
                                    <TabList>
                                        <Tab>Missed Value*</Tab>
                                    </TabList>
                                </Tabs>
                            <Flex
                                direction="column"
                                align="center"
                                w="full"
                                gap={{ base: '20px', sm: '50px' }}
                                textAlign="center"
                            >
                                <Carousel booksWithValues={booksWithValues} netProfits={netProfits}/>
                                <Box alignSelf="flex-end" mt="-10px">
                                    <Link
                                        to={getBestPricePagePath(session?.cid!)}
                                    >
                                        {/* <Button
                                            rightIcon={<ArrowRightIcon />}
                                            variant="unstyled"
                                            border="none"
                                            h="auto"
                                            color={
                                                colorMode == 'light'
                                                    ? 'midnightBlue'
                                                    : 'skyBlue'
                                            }
                                        >
                                            See Details
                                        </Button> */}
                                    </Link>
                                </Box>
                            </Flex>
                        </Box>
                    )}
                </Box>
            </Flex>
            {!loading && (<Text
                size={{ base: 'xs', sm: 's' }}
                mt="-10px"
                >
                    *Missed Value calculations are based on the specific bets you have placed on your linked accounts, historical price data from other platforms, and available bonuses
                </Text>)}
        </Layout>
    );
}
